// @@flow
import axios from 'axios';
import { CONTENTFUL_PATH } from '../constants';

const NAMESPACE = '@@paidy.com/campaign_202109';

export const REQUEST_CAMPAIGN_202109 = `${NAMESPACE}/request_campaign_202109`;
export const RECEIVE_CAMPAIGN_202109_SUCCESS = `${NAMESPACE}/receive_campaign_202109_success`;
export const RECEIVE_CAMPAIGN_202109_FAIL = `${NAMESPACE}/receive_campaign_202109_fail`;

const initialState = { data: {} };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CAMPAIGN_202109: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case RECEIVE_CAMPAIGN_202109_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        data: action.campaign202109,
        updatedAt: action.updatedAt,
      };
    }
    default: {
      return state;
    }
  }
};

const requestCampaign202109 = () => {
  return {
    type: REQUEST_CAMPAIGN_202109,
  };
};

const receiveCampaign202109 = (data) => {
  return {
    type: RECEIVE_CAMPAIGN_202109_SUCCESS,
    campaign202109: data || {},
    updatedAt: Date.now(),
  };
};

const _fetchCampaign202109 = () => {
  return (dispatch) => {
    dispatch(requestCampaign202109());

    return axios
      .get(`${CONTENTFUL_PATH}campaign-202109.json`)
      .then((resp) => dispatch(receiveCampaign202109(resp.data)))
      .catch(console.error);
  };
};

export const fetchCampaign202109 = () => {
  return (dispatch) => dispatch(_fetchCampaign202109());
};

export default reducer;
